import React from "react";
import { useLanguage } from "../../hooks/useLanguage";
import { BsFilterLeft, BsArrowDown } from "react-icons/bs";
import PropTypes from "prop-types";

const radioBtnValue = [
  "recommend",
  "newest",
  "popular",
  "cheapest",
  "expensive",
];

const Sort = ({ selectedBtn: selectedRadioBtn, onChangeSelectedBtn, radioBtn = radioBtnValue }) => {
  const { t } = useLanguage();

  const isRadioSelected = (value) =>
    value === selectedRadioBtn ? true : false;

  return (
    <div className="my-4 pb-2 flex flex-wrap border-b-2 border-slate-300">
      <div className="flex items-center">
        <div className="flex items-center">
          <BsFilterLeft style={{ fontSize: "1.5rem" }} />
          <BsArrowDown />
        </div>
        <h5 className="ltr:ml-1 rtl:mr-1">{t.sort}</h5>
      </div>

      <div className="flex flex-wrap items-center">
        {radioBtn.map((radioInput) => {
          return (
            <div key={radioInput} className="px-1 md:px-2 mx-2 my-1 sm:my-0">
              <label
                htmlFor={radioInput}
                className={`text-sm  cursor-pointer ${radioInput === selectedRadioBtn
                  ? "text-palette-primary font-bold"
                  : "text-palette-mute/80 hover:text-palette-base transition-all"
                  }`}
              >
                {t[radioInput]}
              </label>
              <input
                type="radio"
                className="hidden"
                id={radioInput}
                value={selectedRadioBtn}
                name="sortProduct"
                checked={isRadioSelected(radioInput)}
                onChange={onChangeSelectedBtn}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

Sort.propTypes = {
  selectedBtn: PropTypes.string.isRequired,
  onChangeSelectedBtn: PropTypes.func.isRequired,
  radioBtn: PropTypes.array,
};

export default Sort;
